import { render, staticRenderFns } from "./SolicJobPage.vue?vue&type=template&id=9cffe70c"
import script from "./SolicJobPage.vue?vue&type=script&lang=js"
export * from "./SolicJobPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports